module.exports = __webpack_public_path__ + "static/media/ch.f55af20b.svg";